import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../core/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private options = { headers: new HttpHeaders().set('enctype', 'multipart/form-data') };
  getAPI =  "/api/gtusrllst";
  getUserByIdAPI =  "/api/gtusrdtlsbyid";
  exportUserXlsAPI =  "/api/genrtusrdtlsxls";
  changeStatusAPI =  "/api/chngusrsts";
  updateAPI =  "/api/updtusr";
  addAPI =  "/api/adusr";
  menuOptionAPI =  "/api/gtmnuopts";
  userPermission =  "/api/gtusrprmson";

  taskPermissionOptionsAPI =  "/api/gttskprmsonopts";
  regulatorDocTypeOptionsAPI =  "/api/gtrgltrdctypopts";
  regulatorDocTypeOptionsAPI_InsuranceACQ =  "/api/gtrgltrdctypoptsinsacq";
  locationOptionsAPI =  "/api/gtlctnnopts";
  jurisdictionOptionsAPI =  "/api/gtjurdctnoptsbyrgtrid";
  jurisdictionOptionsAPI_InsuranceACQ =  "/api/gtjurdctnoptsbyrgtridinsacq";
  countryOptionsAPI =  "/api/gtcntryoptsbyjrsdtnid";
  regionOptionsAPI =  "/api/gtrgnoptsbycntryid";

  importUserAPI =  "/api/";

  exportMappedRegulatorAPI= "/api/genrtrgltrdctypxls";

  constructor(
    private http: HttpClient,
    private configService: ConfigService) { }

  Get(pagination: any) {
    return this.http.post(this.getAPI, pagination);
  }

  GetUserById(userId: any) {
    return this.http.post(this.getUserByIdAPI, userId);
  }

  ChangeStatus(statusDetail: { Status: any; ID: any; }) {
    return this.http.post(this.changeStatusAPI, statusDetail);
  }

  ExportToXLS(pagination: any) {
    return this.http.post(this.exportUserXlsAPI, pagination);
  }

  Add(detail: any) {
    return this.http.post(this.addAPI, detail);
  }

  Update(detail: any) {
    return this.http.post(this.updateAPI, detail);
  }


  GetTaskPermissionOptions(details: any) {
    return this.http.post(this.taskPermissionOptionsAPI, details);
  }

  GetRegulatorDocTypeOptions(userId: any) {
    return this.http.post(this.regulatorDocTypeOptionsAPI, userId);
  }

  GetRegulatorDocTypeOptions_InsuranceACQ(userId: any) {
    return this.http.post(this.regulatorDocTypeOptionsAPI_InsuranceACQ, userId);
  }

  GetLocationOptions() {
    return this.http.post(this.locationOptionsAPI, null);
  }

  GetJurisdictionOptions(requlatorIds: any) {
    return this.http.post(this.jurisdictionOptionsAPI, requlatorIds);
  }

  GetJurisdictionOptions_InsuranceACQ(requlatorIds: any) {
    return this.http.post(this.jurisdictionOptionsAPI_InsuranceACQ, requlatorIds);
  }

  GetCountryOptions(jurisdictionId: any) {
    return this.http.post(this.countryOptionsAPI, jurisdictionId);
  }

  GetRegionOptions(countryId: any) {
    return this.http.post(this.regionOptionsAPI, countryId);
  }

  ImportUserList(details: any) {
    return this.http.post(this.importUserAPI, details, this.options);
  }

  ExportMappedRegulatorToXLS(dataId:any) {
    return this.http.post(this.exportMappedRegulatorAPI, dataId);
  }

  GetMenuOptions() {
    return this.http.post(this.menuOptionAPI, null);
  }
  GetUserPermissions(details: any) {
    return this.http.post(this.userPermission, details);
  }
}

